import { render, staticRenderFns } from "./MasterUOM.vue?vue&type=template&id=523d1130&scoped=true"
import script from "./MasterUOM.vue?vue&type=script&lang=js"
export * from "./MasterUOM.vue?vue&type=script&lang=js"
import style0 from "./MasterUOM.vue?vue&type=style&index=0&id=523d1130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d1130",
  null
  
)

export default component.exports